import { assertString } from '@/libs/utils'
import { defineRule } from '../define-rule'
import { now } from '@/utils/date-util'
import { toDate } from '@/libs/utils/parser.util'
import type { BaseRuleConstructorParams } from '../ts/rule-constructor-parameter.type'

export type DateMinAgeRuleConstructorParams = BaseRuleConstructorParams<{
  min: number
  dateFormat?: string
}>

export const dateMinAge = defineRule(
  'date_min_age',
  ({ config, errorMessage }: DateMinAgeRuleConstructorParams) => {
    const { min, dateFormat = 'DD.MM.YYYY' } = config
    const error = errorMessage ?? false
    return (value: string) => {
      try {
        assertString(value)
        const day = toDate(value, dateFormat)
        const minDay = toDate(
          now()
            .subtract(min ?? 0, 'years')
            .format(dateFormat),
          dateFormat
        )
        // Found no other solution to add the isSameOrBefore plugin in typescript rule check
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (day as any).isSameOrBefore(minDay) || error
      } catch (e) {
        console.error('dateMinAge', e)
        return error
      }
    }
  }
)
